<template>
  <div
    class="user-item-main"
    :class="[isHeight ? 'height' : '']"
    @click="$emit('click')">

    <div class="user-item-left" v-if="!leftSlot">{{ name }}</div>
    <div class="user-item-left" v-else><slot name="leftSlot"></slot></div>

    <div class="user-item-right" v-if="rightSlot"><slot name="rightSlot"></slot></div>
    <div class="user-item-right" v-else>
      <span v-if="!value && placeholder" class="no-data">{{placeholder}}</span>
      <span v-if="value">{{ value }}</span>
      <i class="iconfont iconchevron-right" :style="{opacity: showRightIcon ? 1 : 0}"></i>
    </div>
  </div>
</template>
<script>
export default {
  name: 'ItemList',
  props: {
    name: '',
    value: '',
    placeholder: {
      default: '未填写'
    },
    isHeight: {
      type: Boolean,
      default: false
    }, // 高度
    leftSlot: {
      type: Boolean,
      default: false
    },
    rightSlot: {
      type: Boolean,
      default: false,
    },
    // 显示右侧icon
    showRightIcon: {
      type: Boolean,
      default: true
    }
  }
}
</script>
<style lang="scss" scoped>
.user-item-main {
  width: 100%;
  height: 55px;
  position: relative;
  padding: 0 24px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  &.height {
    height: 70px;
  }
  &::after {
    content: "";
    display: block;
    width: calc(100% - 48px);
    height: 1px;
    background: #EEEFF0;
    position: absolute;
    left: 24px;
    bottom: 0;
  }
  .user-item-left {
    font-size: #404040;
  }
  .user-item-right {
    padding-right: 6px;
    .iconfont {
      color: #909090;
      font-size: 14px;
      margin-left: 10px;
    }
  }
  .no-data {
    color: #BCBCBC;
  }
}
</style>
